import React from "react";

export const DownAlignmentArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66797 6L8.0013 9.33333L11.3346 6H4.66797Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
